import { LibraryElementEnum } from 'client/enums/LibraryElementEnum'
import { CommonLibraryElementsCreator } from 'src/editor/shared/entities/common-library-elements-creator'
import { createWebsiteHeader } from 'src/editor/shared/entities/website-header/cerate-website-header'
import { createWebsiteLanguageSwitcher } from 'src/editor/shared/entities/website-language-switcher/create-website-language-switcher'
import { createWebsiteLogo } from 'src/editor/shared/entities/website-logo/create-website-logo'
import { createLoginButton } from 'src/shared/entities/login-button/create-login-button'
import { createRegistrationButton } from 'src/shared/entities/registration-button/create-registration-button'
import { createWebsiteButton } from 'src/shared/entities/website-button/create-website-button'

export class WebsiteLibraryElementsCreator extends CommonLibraryElementsCreator {
  public [LibraryElementEnum.LibraryButton](
    ...args: Parameters<
      (typeof CommonLibraryElementsCreator.prototype)[LibraryElementEnum.LibraryButton]
    >
  ) {
    const button = super[LibraryElementEnum.LibraryButton](...args)
    delete button.border
    delete button.mobileBorder
    delete button.padding
    delete button.mobilePadding
    delete button.background
    delete button.mobileBackground
    delete button.textColor
    delete button.textFontFamily
    delete button.textFontSize
    delete button.textFontWeight
    delete button.textFontStyle
    delete button.lineHeight
    delete button.mobileTextFontFamily
    delete button.mobileTextFontSize
    delete button.mobileTextFontWeight
    delete button.mobileTextFontStyle
    delete button.mobileLineHeight
    delete button.hover?.backgroundColor
    delete button.mobileHover?.backgroundColor

    return button
  }
  public [LibraryElementEnum.LibraryWebsiteButton](
    ...args: Parameters<typeof createWebsiteButton>
  ) {
    return createWebsiteButton(...args)
  }
  public [LibraryElementEnum.LibraryLoginButton](
    ...args: Parameters<typeof createLoginButton>
  ) {
    return createLoginButton(...args)
  }
  public [LibraryElementEnum.LibraryRegistrationButton](
    ...args: Parameters<typeof createRegistrationButton>
  ) {
    return createRegistrationButton(...args)
  }
  public [LibraryElementEnum.LibraryWebsiteHeader](
    ...args: Parameters<typeof createWebsiteHeader>
  ) {
    return createWebsiteHeader(...args)
  }
  public [LibraryElementEnum.LibraryWebsiteLanguageSwitcher](
    ...args: Parameters<typeof createWebsiteLanguageSwitcher>
  ) {
    return createWebsiteLanguageSwitcher(...args)
  }
  public [LibraryElementEnum.LibraryField](
    ...args: Parameters<
      (typeof CommonLibraryElementsCreator.prototype)[LibraryElementEnum.LibraryField]
    >
  ) {
    const field = super[LibraryElementEnum.LibraryField](...args)
    delete field.border
    delete field.mobileBorder
    delete field.padding
    delete field.mobilePadding
    delete field.backgroundColor
    delete field.mobileBackgroundColor
    delete field.color
    delete field.mobileColor
    delete field.mobileFontSize
    delete field.fontSize
    delete field.mobileFontSize
    delete field.mobileFontSize
    delete field.textAlign
    delete field.mobileTextAlign
    delete field.lineHeight
    delete field.mobileLineHeight

    return field
  }
  public [LibraryElementEnum.LibraryMenu](
    ...args: Parameters<
      (typeof CommonLibraryElementsCreator.prototype)[LibraryElementEnum.LibraryMenu]
    >
  ) {
    const menu = super[LibraryElementEnum.LibraryMenu](...args)
    delete menu.fontSize
    delete menu.mobileFontSize
    delete menu.color
    delete menu.mobileColor
    delete menu.subMenuBackgroundColor
    delete menu.sideMenuBackgroundColor
    return menu
  }
  public [LibraryElementEnum.LibraryHeadline](
    ...args: Parameters<
      (typeof CommonLibraryElementsCreator.prototype)[LibraryElementEnum.LibraryHeadline]
    >
  ) {
    const headline = super[LibraryElementEnum.LibraryHeadline](...args)
    delete headline.fontSize
    delete headline.mobileFontSize
    delete headline.lineHeight
    delete headline.mobileLineHeight
    return headline
  }
  public [LibraryElementEnum.LibraryPopup](
    ...args: Parameters<
      (typeof CommonLibraryElementsCreator.prototype)[LibraryElementEnum.LibraryPopup]
    >
  ) {
    const popup = super[LibraryElementEnum.LibraryPopup](...args)
    delete popup.border
    delete popup.mobileBorder
    delete popup.background
    delete popup.mobileBackground
    return popup
  }
  public [LibraryElementEnum.LibraryWebsiteLogo](
    ...args: Parameters<typeof createWebsiteLogo>
  ) {
    return createWebsiteLogo(...args)
  }
  public [LibraryElementEnum.LibraryBulletList](
    ...args: Parameters<
      (typeof CommonLibraryElementsCreator.prototype)[LibraryElementEnum.LibraryBulletList]
    >
  ) {
    const bulletList = super[LibraryElementEnum.LibraryBulletList](...args)
    delete bulletList.fontSize
    delete bulletList.lineHeight
    delete bulletList.textAlign
    delete bulletList.mobileFontSize
    delete bulletList.mobileLineHeight
    delete bulletList.mobileTextAlign
    return bulletList
  }
  public [LibraryElementEnum.LibraryCheckbox](
    ...args: Parameters<
      (typeof CommonLibraryElementsCreator.prototype)[LibraryElementEnum.LibraryCheckbox]
    >
  ) {
    const checkbox = super[LibraryElementEnum.LibraryCheckbox](...args)
    delete checkbox.fontSize
    delete checkbox.textAlign
    delete checkbox.mobileFontSize
    delete checkbox.mobileTextAlign
    return checkbox
  }
  public [LibraryElementEnum.LibraryContentBox](
    ...args: Parameters<
      (typeof CommonLibraryElementsCreator.prototype)[LibraryElementEnum.LibraryContentBox]
    >
  ) {
    const contentBox = super[LibraryElementEnum.LibraryContentBox](...args)
    delete contentBox.header.fontSize
    delete contentBox.header.textAlign
    delete contentBox.header.mobileFontSize
    delete contentBox.header.mobileTextAlign
    delete contentBox.header.color
    delete contentBox.header.mobileColor
    delete contentBox.header.backgroundColor
    delete contentBox.header.mobileBackgroundColor
    return contentBox
  }
  public [LibraryElementEnum.LibraryCountdown](
    ...args: Parameters<
      (typeof CommonLibraryElementsCreator.prototype)[LibraryElementEnum.LibraryCountdown]
    >
  ) {
    const countdown = super[LibraryElementEnum.LibraryCountdown](...args)
    delete countdown.timeStyles.fontSize
    delete countdown.timeStyles.color
    delete countdown.timeStyles.mobileFontSize
    delete countdown.timeStyles.mobileColor
    delete countdown.labelStyles.fontSize
    delete countdown.labelStyles.color
    delete countdown.labelStyles.mobileFontSize
    delete countdown.labelStyles.mobileColor
    return countdown
  }
  public [LibraryElementEnum.LibraryFaq](
    ...args: Parameters<
      (typeof CommonLibraryElementsCreator.prototype)[LibraryElementEnum.LibraryFaq]
    >
  ) {
    const faq = super[LibraryElementEnum.LibraryFaq](...args)
    delete faq.titleColor
    delete faq.titleFontSize
    delete faq.backgroundColor
    delete faq.mobileTitleColor
    delete faq.mobileTitleFontSize
    delete faq.mobileBackgroundColor
    delete faq.mobileTitleColor
    return faq
  }
  public [LibraryElementEnum.LibrarySection](
    ...args: Parameters<
      (typeof CommonLibraryElementsCreator.prototype)[LibraryElementEnum.LibrarySection]
    >
  ) {
    const section = super[LibraryElementEnum.LibrarySection](...args)
    delete section.padding
    delete section.mobilePadding
    delete section.contentWidth
    return section
  }
}
